import {useEffect, useState} from 'react';
import {Text} from '@esgi/ui/typography';
import {
	SelectableListTriggerContent,
	SelectableListRoot,
	SelectableListTrigger,
	IconBox,
	ItemTagAndTitle,
	TriggerWrapper,
	Options,
	TagList,
	Tag,
	IndicatorWrapper, HeaderLabel, SelectableListGroupRoot, SelectableListGroup, NotTestedCounter,
} from '../../index.styled';
import {HeaderRow, StudentIconBox} from './index.styled';
import {AccordionCollapse, AccordionExpand, CorrectAnswer, InCorrectAnswer, UserListItem, UserListItemSelected} from '@esgi/ui';
import {TestListItem} from './components/test-item';
import {StudentListDataItem, TestItem} from '../../../../types';
import {StudentModel} from '@esgi/main/features/assessments';
import {Box} from '@esgi/ui/layout';

interface Props {
	student: StudentListDataItem;
	showAllStudents: boolean;
	isDisabled?: boolean;
	onStartTest: (test: TestItem, student: StudentModel) => void;
}

export function StudentList(props: Props) {
	const {
		student,
		isDisabled,
	} = props;

	const [isItemOpen, setItemOpen] = useState(true);

	useEffect(() => {
		setItemOpen(false);
	}, [props.showAllStudents, props.student]);

	const onTestStart = (test: TestItem) => {
		const studentModel: StudentModel = {
			firstName: student.firstName,
			lastName: student.lastName,
			gradeLevelID: student.gradeLevelID,
			hasCredentials: student.hasCredentials,
			id: student.id,
			photoUrl: student.photoUrl,
			languageID: student.languageID,
		};

		const testModel: TestItem = {
			...test,
			maxScore: test.maxScore,
			untested: test.untested,
			incorrect: test.incorrect,
			correct: test.correct,
		};
		props.onStartTest(testModel, studentModel);
	};

	const ResultsComponent = () => {
		return isItemOpen ? <TagList>
				<Tag type='green'>
					<CorrectAnswer/>
				</Tag>
				<Tag type='red'>
					<InCorrectAnswer/>
				</Tag>
				<Tag>
					<Text size='xxSmall' font='mono' color='neutral64'>NT</Text>
				</Tag>
			</TagList>
			: <NotTestedCounter>
				{student.notTested === 0 ? <><Box /><Text size='small' color='green48'>All tested</Text></> : <>
					<Tag>
						<Text size='xxSmall' font='mono' color='neutral64'>{student.notTested}</Text>
					</Tag>
					<Text size='small' color='neutral80'>Not tested</Text>
				</>}
			</NotTestedCounter>;
	};

	return <SelectableListRoot isListOpen={isItemOpen} onListOpenChange={setItemOpen}>
		<SelectableListGroupRoot>
			<HeaderRow onClick={() => setItemOpen(prev => !prev)} isListOpen={isItemOpen}>
				<ItemTagAndTitle>
					<SelectableListTriggerContent>
						<StudentIconBox>
							{isItemOpen ? <UserListItemSelected /> : <UserListItem />}
						</StudentIconBox>
						<HeaderLabel size='large' isListOpen={isItemOpen}>{student.firstName} {student.lastName}</HeaderLabel>
					</SelectableListTriggerContent>
				</ItemTagAndTitle>

				<Options>
					<IconBox>
						{isDisabled
							? <Text size='small' color='neutral80'>No Results</Text>
							: <ResultsComponent />
						}
					</IconBox>
					<TriggerWrapper>
						<SelectableListTrigger isListOpen={isItemOpen}>
							<IndicatorWrapper>
								{isItemOpen ? <AccordionCollapse /> : <AccordionExpand />}
							</IndicatorWrapper>
						</SelectableListTrigger>
					</TriggerWrapper>
				</Options>
			</HeaderRow>
			<SelectableListGroup>
				{!isDisabled && <TestListItem onTestStart={onTestStart} tests={student.tests} studentId={student.id}/>}
			</SelectableListGroup>
		</SelectableListGroupRoot>
	</SelectableListRoot>;
}

